import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { ReporteService } from 'src/app/services/reportes/reporte.service';
import Swal from 'sweetalert2';
import { GenerateReportActivitiesComponent } from './generate-report/generate-activities-report.component';
import { UserService } from '../../services/users/user.service';
import { AuthService } from 'src/app/services/authFirebase/auth.service';
import { ReportAgents } from '../../models/report-agent';
import { filter } from 'rxjs-compat/operator/filter';
import { MatDialog } from '@angular/material';


@Component({
  selector: 'app-reporte-actividades',
  templateUrl: './reporte-actividades.component.html',
  styleUrls: ['./reporte-actividades.component.scss']
})
export class ReporteActividadesComponent implements OnInit {

  public loader: boolean = false;
  public currentUser: string;

  constructor(
    private dialogService: MatDialog,
  ) { 
     this.currentUser = localStorage.getItem("currentUser")
  }

  ngOnInit() {
  }

  createNew() {
      this.dialogService.open(GenerateReportActivitiesComponent, { height: '60vh' });
    }

}
